import { productCodeToTranslationCode } from '../../../../common/constants/Constant';

export const sortedServiceTypes = [ 'orchestrator', 'aifabric', 'dataservice', 'aiservices', 'testmanager', 'verticalsolutions', 'apps' ];
export const sortedProductCodes = [
    'UNATT',
    'UNATT-HOSTING',
    'NONPR',
    'TAUNATT',
    'APPTESTR',
    'ACR',
    'ATTNU',
    'ATTCU',
    'STDNU',
    'STDCU',
    'STDXNU',
    'STDXCU',
    'AIW',
    'AIG',
    'STDPRONU',
    'STDPROCU',
    'DSU',
    'AIU',
];

export const concurrencyMapping: Record<string, string> = {
    ATTNU: 'ATTCU',
    ATTCU: 'ATTNU',
    STDNU: 'STDCU',
    STDCU: 'STDNU',
    STDXNU: 'STDXCU',
    STDXCU: 'STDXNU',
    STDPRONU: 'STDPROCU',
    STDPROCU: 'STDPRONU',
};

const serviceToProductMapping: Record<string, string[]> = {
    orchestrator: [
        'UNATT',
        'UNATT-HOSTING',
        'NONPR',
        'TAUNATT',
        'APPTESTR',
        'ACR',
        'ATTNU',
        'ATTCU',
        'STDNU',
        'STDCU',
        'STDXNU',
        'STDXCU',
        'STDPRONU',
        'STDPROCU',
        'RU',
        'PERFTEST',
    ],
    aifabric: [
        'AIW',
        'AIG',
    ],
    dataservice: [ 'DSU' ],
    tenant: [ 'AIU', 'AGU', 'HEAL', 'HEALTEST', 'PLTU', 'TEU', 'MRSU', 'LU', 'S2PU', 'SPR', 'APPU', 'RCMU', 'GIC' ],
};
export const getServiceFromProduct = (product: string) => {
    const matchedKV = Object.entries(serviceToProductMapping).find(([ _service, productList ]) => productList.includes(product));

    return matchedKV?.[0];
};

export const productSubLabel = (licenseType: string) => {
    if (licenseType.toLowerCase().indexOf('named') > -1) {
        return 'NAMED_USER';
    } else if (licenseType.toLowerCase() === 'attendedrobots') {
        return 'NAMED_USER';
    } else if (licenseType.toLowerCase().includes('concurrent')) {
        return 'CONCURRENT_USER';
    } else if ([
        'dataserviceunit', 'ru', 'aiu', 'agu', 'heal', 'healtest', 'mrsu', 'lu', 's2pu', 'teu', 'pltu', 'perftest', 'spr', 'appu', 'rcmu', 'gic',
    ].includes(licenseType.toLowerCase())) {
        return '';
    }
    return 'RUNTIME';
};

export const translationCode = (productCode: string) => productCodeToTranslationCode.get(productCode) ?? productCode;
